<div class="wrapper wrapper-content">
  <div class="container-fluid">

    <div class="row">
      <h3>Financiación</h3>
      <div class="col-12 py-2 px-2">
        <p-table [value]="financeLines?.data" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let colHeader of financeColHeaders" class="text-center">{{ colHeader | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-financeLine let-rowIndex="rowIndex">
            <tr [ngClass]="(financeLine.year) ? undefined : 'font-bold font-italic text-center'">
              <td class="text-center">{{ (financeLine.year) ?
                financeLine.year : 'Total'}}</td>
              <td class="text-center">{{financeLine.organic}}</td>
              <td class="text-center">{{financeLine.functional}}</td>
              <td class="text-center">{{financeLine.economical}}</td>
              <td>
                <formatDataValue [type]="'CURRENCY'" [value]="financeLine.budget?.totalAmount"></formatDataValue>
              </td>
            </tr>
          </ng-template>
          <!-- <ng-template pTemplate="summary">
            <tr class="plyca-table-sum">
              <td [attr.colspan]="(financeColHeaders.length - 1)">Total</td>
              <td>{{financeLines?.total}}</td>
            </tr>
          </ng-template> -->
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td [attr.colspan]="financeColHeaders.length">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="row">
      <h3>Presupuesto por lotes</h3>
      <div class="col-12 py-2 px-2">
        <p-table [value]="budgetLines.data" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let colHeader of budgetColHeaders" class="text-center">{{ colHeader | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-lot let-rowIndex="rowIndex">
            <tr [ngClass]="(lot.lotNumber) ? undefined : 'font-bold font-italic text-center'">
              <td class="text-center">{{ (lot.lotNumber) ?
                lot.lotNumber : 'Total'}}</td>
              <td>
                <formatDataValue [type]="'CURRENCY'" [value]="lot.budget?.estimatedAmount || 0">
                </formatDataValue>
              </td>
              <td>
                <formatDataValue [type]="'CURRENCY'" [value]="lot.budget?.amountExcludingTaxes || 0">
                </formatDataValue>
              </td>
              <td class="text-center">{{lot.budget?.taxType?.description}}</td>
              <td class="text-center">{{lot.budget?.taxRate}}</td>
              <td>
                <formatDataValue [type]="'CURRENCY'" [value]="lot.budget?.totalTaxes || 0"></formatDataValue>
              </td>
              <td>
                <formatDataValue [type]="'CURRENCY'" [value]="lot.budget?.totalAmount || 0"></formatDataValue>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td [attr.colspan]="budgetColHeaders.length">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="row">
      <h3>Distribución anualidades/financiación</h3>
      <div class="col-12 py-2 px-2">
        <p-table [value]="distributionLines" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let colHeader of distributionColHeaders" class="text-center">{{ colHeader | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-distributionLine let-rowIndex="rowIndex">
            <tr [ngClass]=" (distributionLine.totalLine) ? 'font-bold' :
                    (distributionLine.summatoryLine) ? 'font-bold font-italic text-center' : undefined">
              <td>{{
                (distributionLine.totalLine) ? 'Total' :
                ((distributionLine.summatoryLine) ? 'Total Lote ' + distributionLine.lot.lotNumber :
                distributionLine.lot.lotNumber)
                }}</td>
              <td class="text-center">{{distributionLine.accountLine?.year}}</td>
              <td class="text-center">{{distributionLine.accountLine?.organic}}</td>
              <td class="text-center">{{distributionLine.accountLine?.functional}}</td>
              <td class="text-center">{{distributionLine.accountLine?.economical}}</td>
              <td>
                <formatDataValue [type]="'CURRENCY'"
                  [value]="(distributionLine.accountLine?.budget?.totalAmount) ? distributionLine.accountLine?.budget?.totalAmount : 0">
                </formatDataValue>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td [attr.colspan]="distributionColHeaders.length">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>